// This program has been developed by students from the bachelor Computer Science at
// Utrecht University within the Software Project course.
// © Copyright Utrecht University (Department of Information and Computing Sciences)

// Filter data based on the given filters
function filterData(data, filters) {
  const activeFilters = filters.filter((item) => item.selected)
  if (activeFilters.length === 0) {
    return [...data]
  }

  return data.filter((obj) => {
    let currentGroup = null
    const groups = []

    activeFilters.forEach((item) => {
      const matches = matchesFilter(obj, item)
      const operator = item.operator || 'and'

      if (currentGroup === null) {
        currentGroup = operator === 'not' ? !matches : matches
      } else if (operator === 'or') {
        groups.push(currentGroup)
        currentGroup = matches
      } else if (operator === 'not') {
        currentGroup = currentGroup && !matches
      } else {
        currentGroup = currentGroup && matches
      }
    })

    return groups.concat(currentGroup).some(Boolean)
  })
}

function matchesFilter(obj, item) {
  if (!item.selected) {
    return true
  }

  switch (item.filterType) {
    case 'string':
    case 'bool':
      return item.input.some((x) => {
        // Handle special missing value cases
        if (x.var === 'no_source') {
          return obj[item.selected].toString() === 'No source available'
        }
        if (x.var === 'unable') {
          return obj[item.selected].toString() === 'Unable to retrieve'
        }
        if (x.var === 'not_applicable') {
          return obj[item.selected].toString() === 'Not applicable for this medicine'
        }

        // If custom input is given, then the filter is only partial
        if (x.custom) {
          const value = obj[item.selected].toString().toLowerCase()
          const searchValue = x.var.toLowerCase()

          switch (x.matchMode || 'contains') {
            case 'startsWith':
              return value.startsWith(searchValue)
            case 'endsWith':
              return value.endsWith(searchValue)
            case 'contains':
            default:
              return value.includes(searchValue)
          }
        }
        // Otherwise they must match exactly
        return obj[item.selected].toString().toLowerCase() === x.var.toLowerCase()
      })
    case 'number':
      return matchesNumber(obj, item)
    case 'date':
      return matchesDate(obj, item)
    default:
      return true
  }
}

// Numerical filter
function matchesNumber(obj, item) {
  // Check if the selected property is a valid number
  const selectedValue = parseFloat(obj[item.selected])

  if (isNaN(selectedValue)) {
    // Handle non-numeric strings based on filterRange
    if (item.input.some((x) => x.filterRange === 'from' || x.filterRange === 'till' || x.filterRange === 'equal')) {
      return false
    }
    return true
  }

  return item.input.every((x) => {
    // Filter the data based on the given numerical range
    if (x.filterRange === 'from') {
      return selectedValue >= x.var
    } else if (x.filterRange === 'till') {
      return selectedValue <= x.var
    } else if (x.filterRange === 'equal') {
      return selectedValue == x.var
    } else if (x.filterRange === 'missing') {
      return isNaN(selectedValue)
    }
    throw new Error('Filter range invalid')
  })
}

// Date filter
function matchesDate(obj, item) {
  const itemDate = new Date(obj[item.selected])

  if (isNaN(itemDate)) {
    // Handle non-date values based on filterRange
    if (item.input.some((x) => x.filterRange === 'from' || x.filterRange === 'till' || x.filterRange === 'equal')) {
      return false
    }
    return true
  }

  return item.input.every((x) => {
    const xDate = new Date(x.var)

    if (x.filterRange === 'from') {
      return xDate <= itemDate
    } else if (x.filterRange === 'till') {
      return xDate >= itemDate
    } else if (x.filterRange === 'equal') {
      // strip datetimes to date, due to different server time
      return (
        xDate.getFullYear() === itemDate.getFullYear() &&
        xDate.getMonth() === itemDate.getMonth() &&
        xDate.getDate() === itemDate.getDate()
      )
    } else if (x.filterRange === 'missing') {
      return isNaN(itemDate)
    }
    throw new Error('Invalid filter type')
  })
}

export default filterData
